import { InsuredTraveler } from '@app/domain/model/eshop/travel/InsuredTraveler';
import { parseLithuanianPersonalCode } from '@app/lib/personal-code/parseLithuanianPersonalCode';
import { validateCompanyCode } from '@app/lib/company-code/validateCompanyCode';
import { ViolationMap } from '@app/lib/form/contracts/ViolationMap';

export function validateInsuredPersons(persons: InsuredTraveler[]): Nullable<ViolationMap> {
    const personViolations: ViolationMap = {};
    let hasErrors = false;

    persons.forEach((person, index) => {
        const errors: ViolationMap = {};

        if (!person.name || person.name.trim().length === 0) {
            errors.name = { message: 'profile.validation.fieldRequired' };
            hasErrors = true;
        }

        if (!person.surname || person.surname.trim().length === 0) {
            errors.surname = { message: 'profile.validation.fieldRequired' };
            hasErrors = true;
        }

        if (!person.personalCode || person.personalCode.trim().length === 0) {
            errors.personalCode = { message: 'profile.validation.fieldRequired' };
            hasErrors = true;
        } else {
            const parsedCode = parseLithuanianPersonalCode(person.personalCode);
            const companyCodeValidation = validateCompanyCode(person.personalCode);

            if (!parsedCode.isValid && !companyCodeValidation.isValid) {
                errors.personalCode = { message: 'eshop.travel.validation.personalCodeInvalid' };
                hasErrors = true;
            } else if (parsedCode.isValid && parsedCode.age !== undefined && parsedCode.age !== person.age) {
                errors.personalCode = { message: 'eshop.travel.ageMismatchError' };
                hasErrors = true;
            }
        }

        if (Object.keys(errors).length > 0) {
            personViolations[index] = errors;
        }
    });

    if (hasErrors) {
        return { insuredPersons: personViolations };
    }

    return null;
}
